import React, { useEffect, useState } from "react";
import "./SectorialIndices.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function SectorialIndices() {

    // WebSocket connection
    const { sectorialIndicesData, strategyIndicesData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    const [sectorData, setSectorData] = useState([]);
    const [strategyData, setStrategyData] = useState([]);
    const [activeTab, setActiveTab] = useState("SECTORIAL_INDICES");

    /* ============================================== */

    useEffect(() => {
        if (Array.isArray(sectorialIndicesData) && sectorialIndicesData.length > 0) {
            setSectorData(sectorialIndicesData);
            // console.log("Sector Data:", sectorialIndicesData);
        }
        // Strategy data
        if (Array.isArray(strategyIndicesData) && strategyIndicesData.length > 0) {
            setStrategyData(strategyIndicesData);
            console.log("Strategy Data:", strategyData);
        }
    }, [sectorialIndicesData, strategyIndicesData]);

    // Header Data
    const headerSource = strategyData?.[0] ?? {};
    const headerData = [
        {
            label1: "Date",
            value1: headerSource?.localDate ?? "--",
            label2: "Time",
            value2: headerSource?.localTime ?? "--",
        },
    ];

    // Helper for color intensity
    const getCardStyle = (pChange) => {
        if (pChange > 2) return { backgroundColor: "#0f7a3f" };
        if (pChange > 1) return { backgroundColor: "#1f9d55" };
        if (pChange > 0) return { backgroundColor: "#7bc47f" };
        if (pChange < -2) return { backgroundColor: "#b71c1c" };
        if (pChange < -1) return { backgroundColor: "#e57373" };
        if (pChange < 0) return { backgroundColor: "#f28b82" };
        return { backgroundColor: "#9e9e9e" };
    };

    return (
        <div className="sectorial-indicies">

            {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">
                    <div className="left-nav header-flex">
                        <div className="logo-container">
                            <img src="/assets/images/noptionwave-logo-1.png" className="header-logo" alt="logo" />
                        </div>

                        {headerData.map((item, idx) => (
                            <div className="header-item" key={idx}>
                                <span className="header-line">{item.label1} : {item.value1}</span>
                                <span className="header-line">{item.label2} : {item.value2}</span>
                            </div>
                        ))}
                    </div>
                </nav>
            </header>

            {/* ===== TABS ===== */}
            <div className="tab">

                <button className={`tablinks sub-header-font ${activeTab === "SECTORIAL_INDICES" ? "active" : ""}`}
                    onClick={() => setActiveTab("SECTORIAL_INDICES")}  >
                    SECTORIAL INDICIES
                </button>

                <button className={`tablinks sub-header-font ${activeTab === "STRATEGY_INDICES" ? "active" : ""}`}
                    onClick={() => setActiveTab("STRATEGY_INDICES")}  >
                    STRATEGY INDICIES
                </button>

            </div>

            {/* ================= GRID ================= */}

            {/* ===== SECTORIAL INDICES ===== */}
            {activeTab === "SECTORIAL_INDICES" && (
                <div className="table-container">

                    <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">SECTORIAL INDICIES</span>
                        </h2>
                    </div>

                    <div className="greed-outer-container">
                        <div className="sector-grid sector-grid-sectorial">
                            {sectorData.map((item, index) => {

                                const isPositive = item.pChange >= 0;

                                return (
                                    <div key={index} className="sector-card" style={getCardStyle(item.pChange)}>

                                        <div className="sector-title">{item.index}</div>

                                        <div className="sector-values">
                                            <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span>
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* ===== ALL SECTORIAL ===== */}
                    <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">ALL SECTORIAL INDICIES</span>
                        </h2>
                    </div>

                    <div className="sectorial-indices-grid">
                        {sectorData.map((item, index) => {

                            const isPositive = item.pChange >= 0;

                            return (
                                <div key={index} className="sectorial-indices-card">

                                    {/* HEADER */}
                                    <div
                                        className="sectorial-indices-stock-header"
                                        style={getCardStyle(item.pChange)}
                                    >
                                        <div className="sectorial-indices-stock-title">
                                            <span>{item.index}</span>

                                            <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span>
                                        </div>
                                    </div>

                                    {/* BODY */}
                                    <div className="greed-outer-container">
                                        <div className="sector-grid">
                                            {(item.sectorialIndicesStockModelList || []).map((stock, index) => {

                                                const isPositive = stock.pChange >= 0;

                                                return (
                                                    <div key={index} className="sector-card" style={getCardStyle(stock.pChange)}>

                                                        <div className="sector-title">{stock.symbol}</div>

                                                        <div className="sector-values">
                                                            <span className="price">
                                                                {Number(stock.lastPrice).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}
                                                            </span>

                                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                                {isPositive ? "+" : ""}
                                                                {stock.pChange}%
                                                            </span>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                </div>
                            );
                        })}
                    </div>

                </div>
            )}

            {/* ===== STRATEGY INDICES ===== */}
            {activeTab === "STRATEGY_INDICES" && (
                <div className="table-container">

                    {/* <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">STRATEGY INDICIES</span>
                        </h2>
                    </div> */}

                    {/* <div className="greed-outer-container">
                        <div className="sector-grid sector-grid-sectorial">
                            {strategyData.map((item, index) => {

                                const isPositive = item.pChange >= 0;

                                return (
                                    <div key={index} className="sector-card" style={getCardStyle(item.pChange)}>

                                        <div className="sector-title">{item.index}</div>

                                        <div className="sector-values">
                                            <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span>
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div> */}
                    {/* ===== ALL SECTORIAL ===== */}
                    {/* <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">ALL STRATEGY INDICIES</span>
                        </h2>
                    </div> */}

                    <div className="sectorial-indices-grid">
                        {strategyData.map((item, index) => {

                            const isPositive = item.pChange >= 0;

                            return (
                                <div key={index} className="sectorial-indices-card">

                                    {/* HEADER */}
                                    <div
                                        className="sectorial-indices-stock-header"
                                        style={getCardStyle(item.pChange)}
                                    >
                                        <div className="sectorial-indices-stock-title">
                                            {/* <span>{item.index}</span> */}
                                            <span className="momentum-stock">
                                                {index === 0 ? "MOMENTUM STOCK" : index === 1 ? "HIGH MOMENTUM STOCK" : `STRATEGY ${index + 1}`}
                                            </span>
                                            {/* <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span> */}
                                        </div>
                                    </div>

                                    {/* BODY */}
                                    <div className="greed-outer-container">
                                        <div className="sector-grid">
                                            {(item.strategyIndicesStockModelList || []).map((stock, index) => {

                                                const isPositive = stock.pChange >= 0;

                                                return (
                                                    <div key={index} className="sector-card" style={getCardStyle(stock.pChange)}>

                                                        <div className="sector-title">{stock.symbol}</div>

                                                        <div className="sector-values">
                                                            <span className="price">
                                                                {Number(stock.lastPrice).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}
                                                            </span>

                                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                                {isPositive ? "+" : ""}
                                                                {stock.pChange}%
                                                            </span>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

        </div>
    );
}